
/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 26 de noviembre de 2025
 */

export const CONTRACTOR_SEARCH_MODEL = {
    contractorId : null,
    date: new Date()
}

export const DEFAULT_CONTRACTOR_PATH = "ALL";

export const CARDS_MODEL = {
    ACTIVE_CONTRACTORS : 'activeContractors',
    EMPLOYEE_INSIDE : 'employeeInside',
    EMPLOYEE_OUTSIDE : 'employeeOutside',
    EQUIPMENT_INSIDE : 'equipmentInside',
    EQUIPMENT_OUTSIDE : 'equipmentOutside'
}

export const MATERIAL_TYPE_MODEL = {
    CLIENT : 'CLIENT_OWNED',
    CONTRACTOR : 'CONTRACTOR_OWNED'
}

export const CHECK_IN_MODEL = {
    userId : null,
    guardId : null,
    guardFullName : '',
    accessDate: null,
    accessType: null,
    note:null,

    set: function (data) {
        return {
            userId: data?.userId || null,
            guardId: data?.guardId || null,
            guardFullName: data?.guardFullName || '',
            accessDate: data?.accessDate || Date.now(),
            accessType: data?.accessType,
            note: data?.note ?? null,
            set: this.set,
            isValid: this.isValid,
            toRegister: this.toRegister
        };
    },
    isValid: function (equipmentList) {
        return equipmentList.length > 0;
    },
    toRegister: function (equipmentList) {
        return {
            userId: this?.userId,
            guardId: this?.guardId,
            accessDate: this.accessDate,
            accessType: this.accessType,
            equipmentList: equipmentList,
            note: this.note
        }
    },
}

export const EQUIPMENT_MODEL = {
    id: null,
    name: '',
    folio: '',
    set: function (data) {
        this.id = data.id || null;
        this.name = data.name || '';
        this.folio = data.folio || '';
        return this;
    },

    toRegister: function () {
        return {
            id: this.id,
            name: this.name.trim(),
            folio: this.folio.trim(),
        };
    }
};
